import { render, staticRenderFns } from "./BeCardAppointment.vue?vue&type=template&id=6eb6e7d7&scoped=true"
import script from "./BeCardAppointment.vue?vue&type=script&lang=js"
export * from "./BeCardAppointment.vue?vue&type=script&lang=js"
import style0 from "./BeCardAppointment.vue?vue&type=style&index=0&id=6eb6e7d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6e7d7",
  null
  
)

export default component.exports